import { DistrictsInterface } from '../../../interfaces/dto/districts/districts-interface';
import { CitiesModel } from '../cities/cities-model';

export class DistrictsModel implements DistrictsInterface {
  id: number = -1;
  districtId: number = -1;
  districtName: string = '';
  name: string = '';
  cities: CitiesModel[] = new Array<CitiesModel>();

  constructor(init?: Partial<DistrictsModel>) {
    Object.assign(this, init);
  }
}
